// src/composables/usePocketNotes.js
import { ref } from 'vue'
import usePocketbase from './usePocketbase'

export function useNotes() {
  const pb = usePocketbase()
  const notes = ref([])
  const note = ref(null)
  const error = ref(null)

  const fetchNotes = async () => {
    try {
      notes.value = await pb
        .collection('notes')
        .getFullList({ requestKey: null })
    } catch (err) {
      error.value = err.message
    }
  }

  const fetchNoteById = async (id) => {
    try {
      note.value = await pb.collection('notes').getOne(id, { requestKey: null })
    } catch (err) {
      error.value = err.message
    }
  }

  return { notes, note, error, fetchNotes, fetchNoteById }
}
